<template>
  <nav id="" class="navbar navbar-expand-lg navbar-absolute fixed-top" :class="navbarClass">
    <div class="container-fluid">
      <div class="navbar-wrapper col-md-1">
        <div class="navbar-minimize">
          <button id="minimizeSidebar" class="btn btn-just-icon btn-white btn-fab btn-round">
            <i class="text_align-center visible-on-sidebar-regular"><dots-vertical-icon /></i>
            <span class="visible-on-sidebar-mini"><view-list-icon /></span>
          </button>
        </div>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index"
        aria-expanded="true" aria-label="Toggle navigation">
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end col-md-11">
        <!-- <div class="searchFormContainerDiv mr-auto" style="">
            <form class="form-inline navbar-form" style="">
              <div class="input-group input-group-search mx-auto">
                <div class="form-outline">
                  <input
                    type="search"
                    id="form1"
                    class="form-control"
                    placeholder="Search"
                    aria-describedby="search-button-addon"
                  />
                </div>
                <div class="input-group-append">
                  <button type="button" class="btn btn-default btnSearchNavbar">
                    <font-awesome-icon
                      icon="fa-solid fa-magnifying-glass"
                      size="xl"
                    />
                  </button>
                </div>
              </div>
            </form>
          </div> -->
        <!-- end search div -->
        <Language v-if="multi_lang == true" :select_language_class="select_language_class"
          :form_group_class="form_group_class" />
        <ul class="nav navbar-nav navbar-right">
          <!-- <li class="nav-item dropdown nav-item-icon-dropdown">
              <b-dropdown
                class="navbarDropdownMenuLinkMID"
                id="navbarDropdownMenuLinkMIDNotification"
                size="sm"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
              >
                <template #button-content>
                  <b-img
                    :src="
                      require('@/assets/images/my-irish-date/notification-nav-icon.png')
                    "
                    width="20px"
                    height="24px"
                  >
                  </b-img>
                  <b-badge variant="primary" :pill="true">4</b-badge>
                </template>
<b-dropdown-item href="#">Notification 1</b-dropdown-item>
<b-dropdown-item href="#">Notification 2</b-dropdown-item>
<b-dropdown-item href="#">Notification 3</b-dropdown-item>
</b-dropdown>
</li>
<li class="nav-item dropdown nav-item-icon-dropdown">
  <b-dropdown class="navbarDropdownMenuLinkMID" id="navbarDropdownMenuLinkMIDInbox" size="sm" variant="link"
    toggle-class="text-decoration-none" no-caret right>
    <template #button-content>
                  <b-img
                    :src="require('@/assets/images/my-irish-date/inbox-nav-icon.png')"
                    width="25px"
                    height="22px"
                  >
                  </b-img>
                  <b-badge variant="primary" :pill="true">2</b-badge>
                </template>
    <b-dropdown-item href="#">Inbox 1</b-dropdown-item>
    <b-dropdown-item href="#">Inbox 2</b-dropdown-item>
    <b-dropdown-item href="#">Inbox 3</b-dropdown-item>
  </b-dropdown>
</li>
<li class="nav-item dropdown nav-item-icon-dropdown align-middle">
  <b-dropdown class="navbarDropdownMenuLinkMID" id="navbarDropdownMenuLinkMIDCalendar" size="sm" variant="link"
    toggle-class="text-decoration-none" no-caret right>
    <template #button-content>
                  <b-img
                    :src="
                      require('@/assets/images/my-irish-date/calendar-nav-icon.png')
                    "
                    width="24px"
                    height="24px"
                  >
                  </b-img>
                  <b-badge variant="primary" :pill="true">60</b-badge>
                </template>
    <b-dropdown-item href="#">Event 1</b-dropdown-item>
    <b-dropdown-item href="#">Event 2</b-dropdown-item>
    <b-dropdown-item href="#">Event 3</b-dropdown-item>
  </b-dropdown>
</li>
<li class="nav-item dropdown ml-2">
  <b-dropdown id="navbarDropdownProfile" class="navbarDropdownMenuLinkMID m-0" size="sm" variant="link"
    toggle-class="text-decoration-none" right no-caret><template #button-content>
                  <div class="row">
                    <div class="col-4 p-0 d-inline-block">
                      <b-avatar :text="avatar_text" rounded class="avatar-irish-date"></b-avatar>
                    </div>
                    <div class="col-8 p-0 pl-1 d-inline-block text-left align-self-center" >
                      <p class="profileNameNavbar profileDataMIDNavbar">{{name}}</p>
                      <p class="profileUserTypeNavbar profileDataMIDNavbar">{{user_type}}</p>
                    </div>
                  </div>
                </template>
    <b-dropdown-item href="#">Edit Password</b-dropdown-item>
  </b-dropdown>
</li> -->
          <!-- <li class="nav-item dropdown">
              <a
                href="#"
                class="nav-link"
                data-toggle="dropdown"
                id="navbarDropdownProfile"
              >
                <div class="userLogoNavbar">
                  <span>SR</span>
                </div>
                <p class="profileNameNavbar">Sara reda</p>
                <p class="profileUserTypeNavbar">admin</p>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdownProfile"
              >
                <a class="dropdown-item" href="">Edit Password</a>
              </div>
            </li> -->
          <li class="nav-item">
            <a href="#" class="nav-link" id="navbarDropdownProfile">
              <p class="profileNameNavbar">{{ name }} </p>
              <p class="profileUserTypeNavbar">{{ user_title ? $t(user_title) : $t(user_type) }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Language from '@/components/Language.vue'

export default {
  name: "NavbarBumblebee",
  props: ['navbarClass', 'multi_lang', 'select_language_class', 'form_group_class', 'user_title'],
  components: { Language },
  data() {
    return {
      name: "",
      user_type: "Admin",
      avatar_text: ""
    };
  },
  mounted() {

    let user = JSON.parse(window.localStorage.getItem("user"));
    this.name = user.name != null ? user.name : user.first_name + ' ' + user.last_name;

    //   let splittedName = user.name.split(' ')
    console.log("title:",this.user_title)
    if (this.user_title) {
      this.user_type = this.user_title
    } else {
      if (user.type == 'user') {
        this.user_type = "customer"
      } else if (user.type == 'operator') {
        this.user_type = 'contractor'
      } else {
        this.user_type = user.type
      }
    }
    // this.user_type = user.type == 'user' ? "Customer" : user.type;

    this.avatar_text = user.first_name.charAt(0) + user.last_name.charAt(0);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/HomeLayout/Navbar.vue